import React from "react";
import styled from "styled-components";
import LineMid from "../../../assets/sprites/paper/line_body.gif";
import LineLeft from "../../../assets/sprites/paper/line_left.gif";
import LineRight from "../../../assets/sprites/paper/line_right.gif";

const Line = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const MidLine = styled.div`
  height: 7px;
  background: url(${LineMid});
  width: calc(100% - 16px);
`;

const LeftLine = styled.div`
  width: 8px;
  height: 7px;
  background: url(${LineLeft});
`;

const RightLine = styled.div`
  width: 8px;
  height: 7px;
  background: url(${LineRight});
`;

export default function HLine() {
  return (
    <Line>
      <LeftLine />
      <MidLine />
      <RightLine />
    </Line>
  );
}
